var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
// benhurEstimateTotals
//
// returns nested collection content with totals
// for activities suitable for combined estimate
// and summaries.

const benhurEstimateTotals = values => {
  const result = {};
  values.forEach(item => {
    const _item$laborCodes = item.laborCodes,
      laborCodes = _item$laborCodes === void 0 ? {} : _item$laborCodes;
    Object.keys(laborCodes).forEach(laborIdentifier => {
      const laborValue = laborCodes[laborIdentifier];
      const laborTitle = laborValue.title,
        laborCreated = laborValue._created,
        _laborValue$activitie = laborValue.activities,
        activities = _laborValue$activitie === void 0 ? {} : _laborValue$activitie;
      Object.keys(activities).forEach(activityIdentifier => {
        const activityValue = activities[activityIdentifier];
        const activityTitle = activityValue.title,
          activityCreated = activityValue._created,
          _activityValue$laborH = activityValue.laborHours,
          laborHours = _activityValue$laborH === void 0 ? 0 : _activityValue$laborH,
          _activityValue$units = activityValue.units,
          units = _activityValue$units === void 0 ? 0 : _activityValue$units,
          _activityValue$unitsT = activityValue.unitsType,
          unitsType = _activityValue$unitsT === void 0 ? {} : _activityValue$unitsT;
        const _Object$keys = Object.keys(unitsType),
          _Object$keys2 = _slicedToArray(_Object$keys, 1),
          unitsTypeIdentifier = _Object$keys2[0];
        if (result[laborIdentifier] === undefined) {
          result[laborIdentifier] = {
            title: laborTitle,
            _created: laborCreated,
            children: {}
          };
        }
        if (result[laborIdentifier].children[activityIdentifier] === undefined) {
          result[laborIdentifier].children[activityIdentifier] = {
            title: activityTitle,
            _created: activityCreated,
            laborHours: 0,
            units: 0,
            unitsTypes: {}
          };
        }
        const resultItem = result[laborIdentifier].children[activityIdentifier];
        resultItem.laborHours += laborHours;
        resultItem.units += units;
        if (unitsTypeIdentifier !== undefined) {
          resultItem.unitsTypes[unitsTypeIdentifier] = unitsType[unitsTypeIdentifier];
        }
      });
    });
  });
  return result;
};
module.exports = {
  benhurEstimateTotals
};